import { useQuery } from '@tanstack/react-query';
import { PrioShareDto } from '../../../../../models/PrioShare';
import { apiGetPrioShares } from '../../../api';

const usePrioShareData = (projectExtensionId?: string) => {
  const {
    data: prioShares = [] as PrioShareDto[],
    isLoading,
    isError,
    refetch,
  } = useQuery({
    queryKey: ['prioShares', projectExtensionId],
    queryFn: async () => {
      const result = await apiGetPrioShares(projectExtensionId!, true);
      return result.data ?? [];
    },
    enabled: !!projectExtensionId,
    staleTime: 30 * 1000,
    refetchOnWindowFocus: false,
  });

  return { prioShares, isLoading, isError, reload: refetch };
};

export default usePrioShareData;
